import { useState, useEffect } from 'react';
import { fetchNaviFlashLoanSupportedSet, getFlashRepaySupported } from '../utils/flashRepayUtils';
/**
 * Returns whether Navi supports flash loan for the given coin type.
 * Fetches full list once, then uses cached Set for instant lookups.
 * Returns false when unknown (no flash on unsupported tokens).
 */
export function useFlashRepaySupported(coinType) {
    const [supported, setSupported] = useState(() => {
        if (!coinType)
            return false;
        const cached = getFlashRepaySupported(coinType);
        return cached !== null && cached !== void 0 ? cached : false;
    });
    useEffect(() => {
        if (!coinType) {
            setSupported(false);
            return;
        }
        const cached = getFlashRepaySupported(coinType);
        if (cached !== undefined) {
            setSupported(cached);
            return;
        }
        let cancelled = false;
        fetchNaviFlashLoanSupportedSet()
            .then(() => {
            var _a;
            if (!cancelled)
                setSupported((_a = getFlashRepaySupported(coinType)) !== null && _a !== void 0 ? _a : false);
        })
            .catch(() => {
            if (!cancelled)
                setSupported(false);
        });
        return () => {
            cancelled = true;
        };
    }, [coinType]);
    return supported;
}
